import { render, staticRenderFns } from "./DialogHold.vue?vue&type=template&id=56e08666&scoped=true&"
import script from "./DialogHold.vue?vue&type=script&lang=js&"
export * from "./DialogHold.vue?vue&type=script&lang=js&"
import style0 from "./DialogHold.vue?vue&type=style&index=0&id=56e08666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e08666",
  null
  
)

export default component.exports